import moment from 'moment'
import CodiceFiscale from 'codice-fiscale-js'
import { COMUNI } from 'codice-fiscale-js/src/lista-comuni'

import { ref, computed } from 'vue'

import { useRegistryStore } from '@/stores/registry.store'
import { useWebSiteStore } from '@/stores/web-site.store'

export const useTaxCode = (currentSubjectSubTypeId) => {
  const registryStore = useRegistryStore()
  const webSiteStore = useWebSiteStore()

  const emptyTaxCodeData = () => ({
    name: null,
    nameExt: null,
    birthDate: null,
    birthCountryId: null,
    birthPlace: null,
    birthCity: null,
    taxCode: null
  })

  const calculatedTaxCodeData = ref(emptyTaxCodeData())

  const resetTaxCodeData = () => { calculatedTaxCodeData.value = emptyTaxCodeData() }

  const isBirthCountryIta = computed(() => webSiteStore.countries.find(x => x.id === calculatedTaxCodeData.value.birthCountryId)?.iso3_code === 'ITA')

  const currentGenderCode = computed(() => {
    const subType = registryStore.getLocalizedSubjectTypes().find(x => x.id === currentSubjectSubTypeId.value)
    const parent = registryStore.subjectTypes.find(x => x.id === subType?.parent_id)
    if (parent?.code !== 'P') return null
    const initials = [subType.code, subType.name].map(value => (value || '').charAt(0).toUpperCase())
    return initials.find(initial => initial === 'M' || initial === 'F') ?? null
  })

  const isTaxCodeCalculationDisabled = computed(() => {
    const data = calculatedTaxCodeData.value
    if (data.taxCode || !data.name || !data.nameExt || !currentGenderCode.value || !data.birthDate || !data.birthCountryId) return true
    return isBirthCountryIta.value && (!data.birthPlace || !data.birthCity)
  })

  const foreignBirthplaceName = (countryName) => {
    const target = (countryName || '').toUpperCase().trim()
    const foreignStates = COMUNI.filter(c => c[1] === 'EE' && c[3] === 1).map(c => c[2])
    return foreignStates.find(name => name === target) ?? foreignStates.find(name => name.startsWith(target)) ?? foreignStates.find(name => name.includes(target)) ?? countryName
  }

  const computeTaxCode = () => {
    const data = calculatedTaxCodeData.value
    const birthDate = moment(data.birthDate)
    const birthCountry = webSiteStore.countries.find(x => x.id === data.birthCountryId)

    const taxCode = CodiceFiscale.compute({
      name: data.nameExt,
      surname: data.name,
      gender: currentGenderCode.value,
      day: birthDate.date(),
      month: birthDate.month() + 1,
      year: birthDate.year(),
      birthplace: isBirthCountryIta.value ? data.birthCity : foreignBirthplaceName(birthCountry?.name),
      ...(isBirthCountryIta.value && { birthplaceProvincia: data.birthPlace }),
    })

    calculatedTaxCodeData.value.taxCode = taxCode
    return taxCode
  }

  return { calculatedTaxCodeData, resetTaxCodeData, isTaxCodeCalculationDisabled, computeTaxCode }
}
